module.exports = __webpack_public_path__ + "img/89.19fc4ee6.jpg";